<template>
  <div>
    <h2 class="h-title">凭证打印</h2>
    <!-- 这里加一条分割线 -->
    <hr />
    <div style="padding:15px">
      <Select v-model="paperType" :datas="paramType" keyName="code" titleName="name"></Select>
      <p></p>
      <div class="container">
        <span class="rowsss">
          <Checkbox v-model="currency" :trueValue="true" :falseValue="false">是否打印外币</Checkbox>
        </span>
        <span class="rowsss">
          <Checkbox v-model="nums" :trueValue="true" :falseValue="false">是否打印数量</Checkbox>
        </span>
        <span class="rowsss">
          <Checkbox v-model="bookkeeper" :trueValue="true" :falseValue="false">打印记账姓名</Checkbox>
          <input v-if="bookkeeper" placeholder="请输入记账人姓名" class="rowss-input" type="text" v-model="bookkeeperName"/>
        </span>
        <span class="rowsss">
          <Checkbox v-model="reviewer" :trueValue="true" :falseValue="false">打印审核姓名</Checkbox>
          <input v-if="reviewer" placeholder="请输入审核人姓名" class="rowss-input" type="text" v-model="reviewerName"/>
        </span>
        <span class="rowsss">
          <Checkbox v-model="cashier" :trueValue="true" :falseValue="false">打印出纳姓名</Checkbox>
          <input v-if="cashier" placeholder="请输入出纳人姓名" class="rowss-input" type="text" v-model="cashierName"/>
        </span>
        <span class="rowsss">
          <Checkbox v-model="maker" :trueValue="true" :falseValue="false">打印制单姓名</Checkbox>
          <input v-if="maker" placeholder="请输入制单人姓名" class="rowss-input" type="text" v-model="makerName"/>
        </span>
      </div>
      <!-- <p>传递的参数：{{params.subparam}}</p> -->
      <div class="container2">
        <span class="container2-span">边距对齐方式：</span>
        <Radio v-model="alignment" :datas="alignmentType" keyName="code" titleName="name"></Radio>
      </div>
    </div>
    <!-- h-modal-footer 将自带modal底部样式 -->
    <footer class="h-modal-footer">
      <button class="h-btn" @click="close">取消</button>
      <button class="h-btn h-btn-primary" @click="success">打印</button>
    </footer>
  </div>
</template>

<script>
import { mapGetters ,mapState} from 'vuex';
export default {
  props: {
    params: Object
  },
  data() {
    return {
      printSet:{},
      cashierName:"",
      makerName:"",
      reviewerName:"",
      bookkeeperName:"",
      cashier:true,
      maker:true,
      reviewer:true,
      bookkeeper:true,
      currency:true,
      nums:true,
      alignment:'CENTER',
      alignmentType: [{ name: '左对齐', code: 'LEFT' }, { name: '居中', code: 'CENTER' }, { name: '右对齐', code: 'RIGHT' }],
      paperType: "A42",
      paramType: [{ name: 'A4两版（推荐）', code: 'A42' }, { name: 'A4三版', code: 'A43' }, { name: 'A4整张（竖）', code: 'A4z' }, { name: 'A4宽12CM*21CM', code: 'A4w' }, { name: '发票14CM*24CM', code: 'Fp' }, { name: 'A5', code: 'A5' },{ name: 'A4整张（横）', code: 'A4h' }]
    };
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters({
      test: 'getTest'
    })
  },
  methods: {
    init(){
      console.log("加载缓存",localStorage.getItem('print' + this.currentAccountSets.id))
      this.printSet =  JSON.parse(localStorage.getItem('print' + this.currentAccountSets.id)) ? JSON.parse(localStorage.getItem('print' + this.currentAccountSets.id)):{
        cashierName:"",
        makerName:"",
        reviewerName:"",
        bookkeeperName:"",
        cashier:true,
        maker:true,
        reviewer:true,
        bookkeeper:true,
        currency:true,
        nums:true,
        alignment:'CENTER',
        alignmentType: [{ name: '左对齐', code: 'LEFT' }, { name: '居中', code: 'CENTER' }, { name: '右对齐', code: 'RIGHT' }],
        paperType: "A42",
        paramType: [{ name: 'A4两版（推荐）', code: 'A42' }, { name: 'A4三版', code: 'A43' }, { name: 'A4整张（竖）', code: 'A4z' }, { name: 'A4宽12CM*21CM', code: 'A4w' }, { name: '发票14CM*24CM', code: 'Fp' }, { name: 'A5', code: 'A5' },{ name: 'A4整张（横）', code: 'A4h' }]
      };
      this.cashierName = this.printSet.cashierName
      this.makerName = this.printSet.makerName
      this.reviewerName = this.printSet.reviewerName
      this.bookkeeperName = this.printSet.bookkeeperName
      this.cashier = this.printSet.cashier
      this.maker = this.printSet.maker
      this.reviewer = this.printSet.reviewer
      this.bookkeeper = this.printSet.bookkeeper
      this.currency = this.printSet.currency
      this.nums = this.printSet.nums
      this.alignment = this.printSet.alignment
      this.alignmentType = this.printSet.alignmentType
      this.paramType = this.printSet.paramType
      this.paperType = this.printSet.paperType

    },
    storeInCache(){
      //写入更新缓存
      this.printSet.cashierName = this.cashierName
      this.printSet.makerName = this.makerName
      this.printSet.reviewerName = this.reviewerName
      this.printSet.bookkeeperName = this.bookkeeperName
      this.printSet.cashier = this.cashier
      this.printSet.maker = this.maker
      this.printSet.reviewer = this.reviewer
      this.printSet.bookkeeper = this.bookkeeper
      this.printSet.currency = this.currency
      this.printSet.nums = this.nums
      this.printSet.alignment = this.alignment
      this.printSet.alignmentType = this.alignmentType
      this.printSet.paramType = this.paramType
      this.printSet.paperType = this.paperType

      localStorage.setItem('print' + this.currentAccountSets.id,JSON.stringify(this.printSet));
    },
    success() {
      //如果state=0，单张的凭证打印，录入窗口调用
      if(this.params.state == 0){
        let url = `/api/pdf/voucher?id=${this.params.subparam}&paperType=${this.paperType}&alignment=${this.alignment}` 
        if(!this.nums){
          url += '&nums=false'
        }
        if(!this.currency){
          url += '&currency=false'
        }
        if(!this.bookkeeper){
          url += '&bookkeeper=false'
        }else{
          url += '&bookkeeper=true&bookkeeperName='+this.bookkeeperName
        }
        if(!this.reviewer){
          url += '&reviewer=false'
        }else{
          url += '&reviewer=true&reviewerName='+this.reviewerName
        }
        if(!this.cashier){
          url += '&cashier=false'
        }else{
          url += '&cashier=true&cashierName='+this.cashierName
        }
        if(!this.maker){
          url += '&maker=false'
        }else{
          url += '&maker=true&makerName='+this.makerName
        }
        window.open(url, '_blank');
        this.close();
      }else if(this.params.state == 1){
        //如果state=1，列表调用打印所有凭证
        let url = `/api/pdf/voucher?paperType=${this.paperType}&alignment=${this.alignment}` 
        if(!this.nums){
          url += '&nums=false'
        }
        if(!this.currency){
          url += '&currency=false'
        }
        if(!this.bookkeeper){
          url += '&bookkeeper=false'
        }else{
          url += '&bookkeeper=true&bookkeeperName='+this.bookkeeperName
        }
        if(!this.reviewer){
          url += '&reviewer=false'
        }else{
          url += '&reviewer=true&reviewerName='+this.reviewerName
        }
        if(!this.cashier){
          url += '&cashier=false'
        }else{
          url += '&cashier=true&cashierName='+this.cashierName
        }
        if(!this.maker){
          url += '&maker=false'
        }else{
          url += '&maker=true&makerName='+this.makerName
        }
        url += '&'+this.params.subparam
        window.open(url, '_blank');
        this.close();
      }else{
        //如果state=2，列表调用打印所选凭证
        let url = `/api/pdf/voucher?paperType=${this.paperType}&alignment=${this.alignment}` 
        if(!this.nums){
          url += '&nums=false'
        }
        if(!this.currency){
          url += '&currency=false'
        }
        if(!this.bookkeeper){
          url += '&bookkeeper=false'
        }else{
          url += '&bookkeeper=true&bookkeeperName='+this.bookkeeperName
        }
        if(!this.reviewer){
          url += '&reviewer=false'
        }else{
          url += '&reviewer=true&reviewerName='+this.reviewerName
        }
        if(!this.cashier){
          url += '&cashier=false'
        }else{
          url += '&cashier=true&cashierName='+this.cashierName
        }
        if(!this.maker){
          url += '&maker=false'
        }else{
          url += '&maker=true&makerName='+this.makerName
        }
        url += '&'+this.params.subparam
        window.open(url, '_blank');
        this.close();
      }
    },
    close() {
      this.storeInCache();
      this.$emit('close');
    }
  },
  created() {
      this.init(); // 在组件创建时调用 initialize 方法
   }
};
</script>
<style scoped>

.h-title {
  margin: 0 0 5px 0;
  font-size: 20px;
}
.container{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
}
.rowsss{
  padding: 8px 0;
  display: flex;
}
.rowss-input{
  border: 1px solid #ccc;
  border-radius: 5px 5px 5px 5px;
  margin-left: 4px;
  padding-left: 4px;
}
.container2{
  display: flex;
}
.container2-span{
  line-height: 32px;
}

</style>